/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SvgCaretDown from '@digital-hig/icon/lib/build/ui-controls/caret-down';
import SvgCaretUp from '@digital-hig/icon/lib/build/ui-controls/caret-up';
import faqs from '../../../constants/faq-constant';
import AccordionList from '../../../common/accordionList';
import { DEFAULT_ACCORDION_SIZE, VIEW_FAQS_ACCORDION } from '../../../constants/app-constants';
import TermsOfUseRootElement from '../TermsOfUse/style';

const TermsOfUse = () => {
  const { t } = useTranslation();
  const [toggleShow, setToggleShow] = useState(false);
  const param = useParams();
  return (
    <TermsOfUseRootElement>
      <Box className="page-container">
        <Typography
          variant="headline-medium"
          className="FAQ-heading md:dhig-w-9/12 lg:dhig-w-3/5 sm:dhig-mb-7 lg:dhig-mb-8 "
          component="h2"
        >
          {t('Frequently asked questions (FAQs)')}
        </Typography>
        <AccordionList
          dataWatLoc="faqs"
          items={toggleShow ? faqs : Object.fromEntries(Object.entries(faqs || {}).slice(0, VIEW_FAQS_ACCORDION))}
          size={DEFAULT_ACCORDION_SIZE}
        />
        <Typography
          onClick={() => setToggleShow(!toggleShow)}
          variant="headline-smaller"
          className="see-more-button"
        >
          {toggleShow ? (
            <>
              {t('See less')}
              {param.locale !== 'jp' && (
                <>
                  {' '}
                  {t('FAQs')}
                </>
              )}
              <SvgCaretUp width="12px" />
              {' '}
            </>
          ) : (
            <>
              {t('See more')}
              {param.locale !== 'jp' && (
                <>
                  {' '}
                  {t('FAQs')}
                </>
              )}
              <SvgCaretDown width="12px" />
            </>
          )}
        </Typography>
      </Box>
    </TermsOfUseRootElement>
  );
};

export default TermsOfUse;
